export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/Parents.80f112a5.svg","height":23,"width":124};